import { AuthConfig } from '@auth';
import { Config } from '../../models/config.interface';

export const authConfigFactory = (config: Config): AuthConfig => ({
  authApi: config.authApi,
  recaptchaSession: true,
  userApi: config.userApi,
});
